import styled from '@emotion/styled';
import { useMemo, useRef } from 'react';
import { getMFEConfig } from '@sunrun/sales-experience-shared';
import { useAnalyticsIframeMessages } from 'hooks/useAnalyticsIframeMessages';

type AnalyticsIFrameProps = {
  jwt: string;
  email: string;
};

const AnalyticsIFrame = ({ jwt, email }: AnalyticsIFrameProps) => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const { basePath, src, title } = useMemo(() => {
    const config = getMFEConfig('analytics', 'analytics');
    return {
      basePath: config.iFrameUrl,
      src: config.iFrameUrl,
      title: config.title,
    };
  }, []);

  useAnalyticsIframeMessages(ref);

  const queryString = `jwt=${jwt}&email=${email}`;
  const baseUrl = `${basePath}?${queryString}`;
  const srcUrl = `${src}?${queryString}`;

  return (
    <IFrameContainer
      key={baseUrl}
      ref={ref}
      src={srcUrl}
      title={title}
      allow="geolocation; fullscreen; clipboard-write;"
    />
  );
};

const IFrameContainer = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  flex: 1;
  display: block;
`;

export { AnalyticsIFrame };
